import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_LEADS_ROUTE, COMPANY_LEADS_ROUTE } from "./Leads.path";
import { ALLOWED_MODULES } from "../../constants/enums";

const Leads = Loadable(
	lazy(() =>
		import("./Leads").then(({ Leads }) => ({
			default: Leads,
		}))
	)
);
const CompanyLeadsList = Loadable(
	lazy(() =>
		import("./CompanyLeadsList").then(({ CompanyLeadsList }) => ({
			default: CompanyLeadsList,
		}))
	)
);

const ManageLead = Loadable(
	lazy(() =>
		import("./ManageLead").then(({ ManageLead }) => ({
			default: ManageLead,
		}))
	)
);

export const leadRoutes = [
	{
		path: APP_LEADS_ROUTE,
		exact: true,
		element: (
			<AuthorizedRoute

				moduleIds={[ALLOWED_MODULES.LEADS]}
			>
				<Leads />
			</AuthorizedRoute>
		),
	},
	{
		path: COMPANY_LEADS_ROUTE,
		exact: true,
		element: (
			<AuthorizedRoute

				moduleIds={[ALLOWED_MODULES.LEADS]}
			>
				<CompanyLeadsList />
			</AuthorizedRoute>
		),
	},
	{
		path: `${APP_LEADS_ROUTE}/manage`,
		exact: true,
		element: (
			<AuthorizedRoute

				moduleIds={[ALLOWED_MODULES.LEADS]}
			>
				<ManageLead />
			</AuthorizedRoute>
		),
	},
	{
		path: `${APP_LEADS_ROUTE}/manage/:uuid`,
		exact: true,
		element: (
			<AuthorizedRoute

				moduleIds={[ALLOWED_MODULES.LEADS]}
			>
				<ManageLead />
			</AuthorizedRoute>
		),
	},
];
